import { nextTick, shallowRef } from 'vue';
import type { FormInstance } from 'element-plus';

/** el-form 校验提交副本，输入框仍绑定原模型；失败不覆盖用户输入。 */
export function useSubmitValidation<T extends object>() {
  const validationModel = shallowRef<T | null>(null);
  const submitting = shallowRef(false);
  const validatePayload = async (form: FormInstance | undefined, payload: T, fields?: string[]): Promise<boolean> => {
    if (!form) return false;
    validationModel.value = payload;
    await nextTick();
    try {
      return fields ? await form.validateField(fields) : await form.validate();
    } catch {
      return false;
    } finally {
      validationModel.value = null;
      await nextTick();
    }
  };
  return { validationModel, submitting, validatePayload };
}
